import { t } from 'services/i18n.service';

const ImageError = () => {
  return (
    <div className='w-full h-full flex flex-col items-center justify-center ~gap-1/2 ~p-2/3'>
      <svg
        className='~w-6/8 ~h-6/8 text-red-600 dark:text-red-400'
        fill='none'
        viewBox='0 0 24 24'
        stroke='currentColor'>
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
        />
      </svg>
      <p className='~text-[0.625rem]/xs text-red-600 dark:text-red-400 text-center'>
        {t('tabs_revamp.instructions_tab.failed_to_load')}
      </p>
    </div>
  );
};

export default ImageError;
